// extracted by mini-css-extract-plugin
export default {"LoginPage":"Login_LoginPage__wWKlu","LoginForm":"Login_LoginForm__Ddg8t"};